export default __webpack_public_path__ + "static/media/CUBS-Upload.e045763a.png";